import React from 'react';
import {Skeleton} from '@zooplus/ui-components';

const SkeletonShutdown = ({}): JSX.Element => {
  return (
    <div>
      <Skeleton style={{ marginTop: '40px', height: '312px' }}  />
      <Skeleton style={{ marginTop: '45px', height: '148px' }} />
      <Skeleton style={{ marginTop: '40px', height: '335px' }} />
    </div>
  );
};
export default SkeletonShutdown;
